/**
 * Domain Constants for Frontend
 *
 * These constants are duplicated from schools-domain-backend-utils
 * to avoid pulling Node.js dependencies into the browser bundle.
 */

// ============================================================================
// COUNTRY CONSTANTS (ISO 3166-1 alpha-2)
// ============================================================================

export type CountryIsoCode =
  | 'AF'
  | 'AX'
  | 'AL'
  | 'DZ'
  | 'AS'
  | 'AD'
  | 'AO'
  | 'AI'
  | 'AQ'
  | 'AG'
  | 'AR'
  | 'AM'
  | 'AW'
  | 'AU'
  | 'AT'
  | 'AZ'
  | 'BH'
  | 'BS'
  | 'BD'
  | 'BB'
  | 'BY'
  | 'BE'
  | 'BZ'
  | 'BJ'
  | 'BM'
  | 'BT'
  | 'BO'
  | 'BQ'
  | 'BA'
  | 'BW'
  | 'BV'
  | 'BR'
  | 'IO'
  | 'BN'
  | 'BG'
  | 'BF'
  | 'BI'
  | 'KH'
  | 'CM'
  | 'CA'
  | 'CV'
  | 'KY'
  | 'CF'
  | 'TD'
  | 'CL'
  | 'CN'
  | 'CX'
  | 'CC'
  | 'CO'
  | 'KM'
  | 'CG'
  | 'CD'
  | 'CK'
  | 'CR'
  | 'CI'
  | 'HR'
  | 'CU'
  | 'CW'
  | 'CY'
  | 'CZ'
  | 'DK'
  | 'DJ'
  | 'DM'
  | 'DO'
  | 'EC'
  | 'EG'
  | 'SV'
  | 'GQ'
  | 'ER'
  | 'EE'
  | 'ET'
  | 'FK'
  | 'FO'
  | 'FJ'
  | 'FI'
  | 'FR'
  | 'GF'
  | 'PF'
  | 'TF'
  | 'GA'
  | 'GM'
  | 'GE'
  | 'DE'
  | 'GH'
  | 'GI'
  | 'GR'
  | 'GL'
  | 'GD'
  | 'GP'
  | 'GU'
  | 'GT'
  | 'GG'
  | 'GN'
  | 'GW'
  | 'GY'
  | 'HT'
  | 'HM'
  | 'VA'
  | 'HN'
  | 'HK'
  | 'HU'
  | 'IS'
  | 'IN'
  | 'ID'
  | 'IR'
  | 'IQ'
  | 'IE'
  | 'IM'
  | 'IL'
  | 'IT'
  | 'JM'
  | 'JP'
  | 'JE'
  | 'JO'
  | 'KZ'
  | 'KE'
  | 'KI'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KG'
  | 'LA'
  | 'LV'
  | 'LB'
  | 'LS'
  | 'LR'
  | 'LY'
  | 'LI'
  | 'LT'
  | 'LU'
  | 'MO'
  | 'MK'
  | 'MG'
  | 'MW'
  | 'MY'
  | 'MV'
  | 'ML'
  | 'MT'
  | 'MH'
  | 'MQ'
  | 'MR'
  | 'MU'
  | 'YT'
  | 'MX'
  | 'FM'
  | 'MD'
  | 'MC'
  | 'MN'
  | 'ME'
  | 'MS'
  | 'MA'
  | 'MZ'
  | 'MM'
  | 'NA'
  | 'NR'
  | 'NP'
  | 'NL'
  | 'NC'
  | 'NZ'
  | 'NI'
  | 'NE'
  | 'NG'
  | 'NU'
  | 'NF'
  | 'MP'
  | 'NO'
  | 'OM'
  | 'PK'
  | 'PW'
  | 'PS'
  | 'PA'
  | 'PG'
  | 'PY'
  | 'PE'
  | 'PH'
  | 'PN'
  | 'PL'
  | 'PT'
  | 'PR'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RU'
  | 'RW'
  | 'BL'
  | 'SH'
  | 'KN'
  | 'LC'
  | 'MF'
  | 'PM'
  | 'VC'
  | 'WS'
  | 'SM'
  | 'ST'
  | 'SA'
  | 'SN'
  | 'RS'
  | 'SC'
  | 'SL'
  | 'SG'
  | 'SX'
  | 'SK'
  | 'SI'
  | 'SB'
  | 'SO'
  | 'ZA'
  | 'GS'
  | 'SS'
  | 'ES'
  | 'LK'
  | 'SD'
  | 'SR'
  | 'SJ'
  | 'SZ'
  | 'SE'
  | 'CH'
  | 'SY'
  | 'TW'
  | 'TJ'
  | 'TZ'
  | 'TH'
  | 'TL'
  | 'TG'
  | 'TK'
  | 'TO'
  | 'TT'
  | 'TN'
  | 'TR'
  | 'TM'
  | 'TC'
  | 'TV'
  | 'UG'
  | 'UA'
  | 'AE'
  | 'GB'
  | 'US'
  | 'UM'
  | 'UY'
  | 'UZ'
  | 'VU'
  | 'VE'
  | 'VN'
  | 'VG'
  | 'VI'
  | 'WF'
  | 'EH'
  | 'YE'
  | 'ZM'
  | 'ZW';

export const COUNTRY_NAMES: Record<CountryIsoCode, string> = {
  AF: 'Afghanistan',
  AX: 'Åland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BH: 'Bahrain',
  BS: 'Bahamas',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, the Democratic Republic of the',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Côte d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea, Democratic People's Republic of",
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the Former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan, Province of China',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

// ============================================================================
// GENDER CONSTANTS
// ============================================================================

export type GenderCode = 'male' | 'female' | 'other';

export const GENDER_NAMES: Record<GenderCode, string> = {
  male: 'Male',
  female: 'Female',
  other: 'Other',
};

// ============================================================================
// LANGUAGE CONSTANTS (ISO 639-2/B codes)
// ============================================================================

export type LanguageIsoCode =
  | 'abk'
  | 'aar'
  | 'afr'
  | 'aka'
  | 'alb'
  | 'amh'
  | 'ara'
  | 'arg'
  | 'arm'
  | 'asm'
  | 'ava'
  | 'ave'
  | 'aym'
  | 'aze'
  | 'bam'
  | 'bak'
  | 'baq'
  | 'bel'
  | 'ben'
  | 'bis'
  | 'bos'
  | 'bre'
  | 'bul'
  | 'bur'
  | 'cat'
  | 'cha'
  | 'che'
  | 'nya'
  | 'chi'
  | 'chu'
  | 'chv'
  | 'cor'
  | 'cos'
  | 'cre'
  | 'hrv'
  | 'cze'
  | 'dan'
  | 'div'
  | 'dut'
  | 'dzo'
  | 'eng'
  | 'epo'
  | 'est'
  | 'ewe'
  | 'fao'
  | 'fij'
  | 'fin'
  | 'fre'
  | 'fry'
  | 'ful'
  | 'gla'
  | 'glg'
  | 'lug'
  | 'geo'
  | 'ger'
  | 'gre'
  | 'kal'
  | 'grn'
  | 'guj'
  | 'hat'
  | 'hau'
  | 'heb'
  | 'her'
  | 'hin'
  | 'hmo'
  | 'hun'
  | 'ice'
  | 'ido'
  | 'ibo'
  | 'ind'
  | 'ina'
  | 'ile'
  | 'iku'
  | 'ipk'
  | 'gle'
  | 'ita'
  | 'jpn'
  | 'jav'
  | 'kan'
  | 'kau'
  | 'kas'
  | 'kaz'
  | 'khm'
  | 'kik'
  | 'kin'
  | 'kir'
  | 'kom'
  | 'kon'
  | 'kor'
  | 'kua'
  | 'kur'
  | 'lao'
  | 'lat'
  | 'lav'
  | 'lim'
  | 'lin'
  | 'lit'
  | 'lub'
  | 'ltz'
  | 'mac'
  | 'mlg'
  | 'may'
  | 'mal'
  | 'mlt'
  | 'glv'
  | 'mao'
  | 'mar'
  | 'mah'
  | 'mon'
  | 'nau'
  | 'nav'
  | 'nde'
  | 'nbl'
  | 'ndo'
  | 'nep'
  | 'nor'
  | 'nob'
  | 'nno'
  | 'iii'
  | 'oci'
  | 'oji'
  | 'ori'
  | 'orm'
  | 'oss'
  | 'pli'
  | 'pus'
  | 'per'
  | 'pol'
  | 'por'
  | 'pan'
  | 'que'
  | 'rum'
  | 'roh'
  | 'run'
  | 'rus'
  | 'sme'
  | 'smo'
  | 'sag'
  | 'san'
  | 'srd'
  | 'srp'
  | 'sna'
  | 'snd'
  | 'sin'
  | 'slo'
  | 'slv'
  | 'som'
  | 'sot'
  | 'spa'
  | 'sun'
  | 'swa'
  | 'ssw'
  | 'swe'
  | 'tgl'
  | 'tah'
  | 'tgk'
  | 'tam'
  | 'tat'
  | 'tel'
  | 'tha'
  | 'tib'
  | 'tir'
  | 'ton'
  | 'tso'
  | 'tsn'
  | 'tur'
  | 'tuk'
  | 'twi'
  | 'uig'
  | 'ukr'
  | 'urd'
  | 'uzb'
  | 'ven'
  | 'vie'
  | 'vol'
  | 'wln'
  | 'wel'
  | 'wol'
  | 'xho'
  | 'yid'
  | 'yor'
  | 'zha'
  | 'zul';

export const LANGUAGE_NAMES: Record<LanguageIsoCode, string> = {
  abk: 'Abkhazian',
  aar: 'Afar',
  afr: 'Afrikaans',
  aka: 'Akan',
  alb: 'Albanian',
  amh: 'Amharic',
  ara: 'Arabic',
  arg: 'Aragonese',
  arm: 'Armenian',
  asm: 'Assamese',
  ava: 'Avaric',
  ave: 'Avestan',
  aym: 'Aymara',
  aze: 'Azerbaijani',
  bam: 'Bambara',
  bak: 'Bashkir',
  baq: 'Basque',
  bel: 'Belarusian',
  ben: 'Bengali',
  bis: 'Bislama',
  bos: 'Bosnian',
  bre: 'Breton',
  bul: 'Bulgarian',
  bur: 'Burmese',
  cat: 'Catalan, Valencian',
  cha: 'Chamorro',
  che: 'Chechen',
  nya: 'Chichewa, Chewa, Nyanja',
  chi: 'Chinese',
  chu: 'Church Slavonic, Old Slavonic, Old Church Slavonic',
  chv: 'Chuvash',
  cor: 'Cornish',
  cos: 'Corsican',
  cre: 'Cree',
  hrv: 'Croatian',
  cze: 'Czech',
  dan: 'Danish',
  div: 'Divehi, Dhivehi, Maldivian',
  dut: 'Dutch, Flemish',
  dzo: 'Dzongkha',
  eng: 'English',
  epo: 'Esperanto',
  est: 'Estonian',
  ewe: 'Ewe',
  fao: 'Faroese',
  fij: 'Fijian',
  fin: 'Finnish',
  fre: 'French',
  fry: 'Western Frisian',
  ful: 'Fulah',
  gla: 'Gaelic, Scottish Gaelic',
  glg: 'Galician',
  lug: 'Ganda',
  geo: 'Georgian',
  ger: 'German',
  gre: 'Greek, Modern (1453–)',
  kal: 'Kalaallisut, Greenlandic',
  grn: 'Guarani',
  guj: 'Gujarati',
  hat: 'Haitian, Haitian Creole',
  hau: 'Hausa',
  heb: 'Hebrew',
  her: 'Herero',
  hin: 'Hindi',
  hmo: 'Hiri Motu',
  hun: 'Hungarian',
  ice: 'Icelandic',
  ido: 'Ido',
  ibo: 'Igbo',
  ind: 'Indonesian',
  ina: 'Interlingua (International Auxiliary Language Association)',
  ile: 'Interlingue, Occidental',
  iku: 'Inuktitut',
  ipk: 'Inupiaq',
  gle: 'Irish',
  ita: 'Italian',
  jpn: 'Japanese',
  jav: 'Javanese',
  kan: 'Kannada',
  kau: 'Kanuri',
  kas: 'Kashmiri',
  kaz: 'Kazakh',
  khm: 'Central Khmer',
  kik: 'Kikuyu, Gikuyu',
  kin: 'Kinyarwanda',
  kir: 'Kirghiz, Kyrgyz',
  kom: 'Komi',
  kon: 'Kongo',
  kor: 'Korean',
  kua: 'Kuanyama, Kwanyama',
  kur: 'Kurdish',
  lao: 'Lao',
  lat: 'Latin',
  lav: 'Latvian',
  lim: 'Limburgan, Limburger, Limburgish',
  lin: 'Lingala',
  lit: 'Lithuanian',
  lub: 'Luba-Katanga',
  ltz: 'Luxembourgish, Letzeburgesch',
  mac: 'Macedonian',
  mlg: 'Malagasy',
  may: 'Malay',
  mal: 'Malayalam',
  mlt: 'Maltese',
  glv: 'Manx',
  mao: 'Maori',
  mar: 'Marathi',
  mah: 'Marshallese',
  mon: 'Mongolian',
  nau: 'Nauru',
  nav: 'Navajo, Navaho',
  nde: 'North Ndebele',
  nbl: 'South Ndebele',
  ndo: 'Ndonga',
  nep: 'Nepali',
  nor: 'Norwegian',
  nob: 'Norwegian Bokmål',
  nno: 'Norwegian Nynorsk',
  iii: 'Sichuan Yi, Nuosu',
  oci: 'Occitan',
  oji: 'Ojibwa',
  ori: 'Oriya',
  orm: 'Oromo',
  oss: 'Ossetian, Ossetic',
  pli: 'Pali',
  pus: 'Pashto, Pushto',
  per: 'Persian',
  pol: 'Polish',
  por: 'Portuguese',
  pan: 'Punjabi, Panjabi',
  que: 'Quechua',
  rum: 'Romanian, Moldavian, Moldovan',
  roh: 'Romansh',
  run: 'Rundi',
  rus: 'Russian',
  sme: 'Northern Sami',
  smo: 'Samoan',
  sag: 'Sango',
  san: 'Sanskrit',
  srd: 'Sardinian',
  srp: 'Serbian',
  sna: 'Shona',
  snd: 'Sindhi',
  sin: 'Sinhala, Sinhalese',
  slo: 'Slovak',
  slv: 'Slovenian',
  som: 'Somali',
  sot: 'Southern Sotho',
  spa: 'Spanish, Castilian',
  sun: 'Sundanese',
  swa: 'Swahili',
  ssw: 'Swati',
  swe: 'Swedish',
  tgl: 'Tagalog',
  tah: 'Tahitian',
  tgk: 'Tajik',
  tam: 'Tamil',
  tat: 'Tatar',
  tel: 'Telugu',
  tha: 'Thai',
  tib: 'Tibetan',
  tir: 'Tigrinya',
  ton: 'Tonga (Tonga Islands)',
  tso: 'Tsonga',
  tsn: 'Tswana',
  tur: 'Turkish',
  tuk: 'Turkmen',
  twi: 'Twi',
  uig: 'Uighur, Uyghur',
  ukr: 'Ukrainian',
  urd: 'Urdu',
  uzb: 'Uzbek',
  ven: 'Venda',
  vie: 'Vietnamese',
  vol: 'Volapük',
  wln: 'Walloon',
  wel: 'Welsh',
  wol: 'Wolof',
  xho: 'Xhosa',
  yid: 'Yiddish',
  yor: 'Yoruba',
  zha: 'Zhuang, Chuang',
  zul: 'Zulu',
};
